import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
 
import { CardItemComponent } from './card-item.component';

const COMPONENTS = [CardItemComponent];

@NgModule({
  imports: [CommonModule, NzAvatarModule, NzToolTipModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class CardItemModule {}
